
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import EcoPilot from '../../components/feature/EcoPilot';
import Hero from './components/Hero';
import Services from './components/Services';
import Process from './components/Process';
import FAQ from './components/FAQ';
import CTA from './components/CTA';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <Services />
        <Process />
        <FAQ />
        <CTA />
      </main>
      <Footer />
      <WhatsAppButton />
      <EcoPilot />
    </div>
  );
}
